export default "__VITE_ASSET__3be0b15c__"